import React from 'react'
import { InputItemWrap, InputLabel, DHA, AuthButton, ForgotPasswordButton, FormContainer, LoginHeader, FormMain, LoginFooter, FormMainHeader, InputFieldItem } from 'pages/auth/auth.styled'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'  
import { login, loginOrganization } from '../../features/auth/authSlice'
import { setForgotPasswordUserType, setViewForgotPassword } from '../../features/auth/authSlice'  
import ReCAPTCHA from 'react-google-recaptcha'
import { useEffect, useRef} from 'react' 
import SelectUserType from './SelectUserType'
import SpinnerSmall from 'components/SpinnerSmall'
import { useTranslation } from 'react-i18next'


export default function LoginForm() {

    const { t } = useTranslation('auth')

    const dispatch = useDispatch()
    const recaptcha = useRef();
    const email = useRef();
    const password = useRef();
    const navigate = useNavigate() 
    const { user, userType, isLoginLoading, isError, isLoginSuccess, message } = useSelector( (state) => state.auth )
 
    const handleNavigate = () => {
        navigate('/register')
    }

    const handleLogin = () => {
        const token = recaptcha.current.getValue(); 

        if(!token){
            toast.error(t('login.captchaRequired'))
            return
        }

        if(userType === 'church'){
            dispatch(loginOrganization({
                email: email.current.value,
                password: password.current.value,
                captchaValue: token
            }))
        }else{ 
            dispatch(login({ 
                email:  email.current.value,
                password: password.current.value,
                captchaValue: token 
            }))
        }
    }

    const handleForgotPassword = () => {
        dispatch(setForgotPasswordUserType(userType))
        dispatch(setViewForgotPassword(true))
    }

    useEffect(() => {
        if (!user) {  navigate('/login') }
        if (isError) { toast.error(message) }

        if ( !isLoginLoading && (isLoginSuccess || user)) { 
            if(userType === 'church'){
                navigate(`/${user.name}`)
            }else{
                navigate(`/home`)
            }
        }
        else if( !isLoginLoading && (isLoginSuccess || user) && user.isChurch){ 
            navigate('/home') 
        }
 
    }, [ isLoginLoading, user, isError, isLoginSuccess, message, navigate, dispatch])
    

    return (
        <FormContainer>
            <LoginHeader
                onClick={() => navigate('/')}
                >
                <img
                    
                    style={{ width: "100px", height: "40px" }} 
                    src={require("../../prayselyLogo.png")} alt="logo" />
            </LoginHeader>
            <FormMain>  
                <FormMainHeader>
                    <h1>{t('login.welcome')}</h1>
                    <p>{t('login.title')}</p>
                </FormMainHeader>
 
                <SelectUserType 
                    userTooltip={t('login.memberTooltip')}
                    churchTooltip={t('login.churchTooltip')}
                    />

                {
                    userType !== 'none' && (
                        <>
                            <InputItemWrap>
                                <InputLabel
                                    htmlFor='email'
                                    >
                                    {t('login.emailPlaceholder')}
                                </InputLabel>
                                <InputFieldItem>
                                    <input
                                        ref={email} 
                                        type="email"
                                        id='email'
                                        name='email' 
                                        placeholder={t('login.emailPlaceholder')}
                                        /> 
                                </InputFieldItem>
                            </InputItemWrap>
                            <InputItemWrap>
                                <InputLabel
                                    htmlFor='password'
                                    >
                                    {t('login.passwordPlaceholder')}
                                </InputLabel>
                                <InputFieldItem>
                                    <input
                                        ref={password}
                                        type="password" 
                                        name='password'
                                        placeholder={t('login.passwordPlaceholder')}
                                        />
                                </InputFieldItem>
                            </InputItemWrap>
            
                            <ForgotPasswordButton
                                onClick={handleForgotPassword}
                                > <span>{t('login.forgotPassword')}</span> </ForgotPasswordButton>
                            <ReCAPTCHA 
                                ref={recaptcha}
                                sitekey={"6LfmM8QqAAAAANqh0Ia0RyQIGjJ3hHDK5EB-f6Xr"}
                                />
            
            
                            <AuthButton 
                                disabled={isLoginLoading}
                                onClick={handleLogin} >
                                {
                                    isLoginLoading ? 
                                    (
                                        <SpinnerSmall /> 
                                    )
                                    :
                                    (
                                      <span>{t('login.loginAs', { accountType: t(`accountType.${userType === 'user' ? 'member' : 'church'}`) })}</span>
                                    )
                                }
                                    
                            </AuthButton>
                            
                            <DHA>
                                <span>{t('login.noAccount')}</span>
                                <p
                                    onClick={handleNavigate}
                                    >{t('login.createAccount')}
                                </p>
                                
                            </DHA>
                        </>
                    )
                }

            </FormMain>
            <LoginFooter>
                <span> &copy; 2025 Praysely, Inc </span>
            </LoginFooter>
        </FormContainer>
    )
}
